<template>

  <header class="ad_wrap head" :class="{ home: isCurrentGNB('home')}">
    <div class="inner">

      <display-container :section="102" empty-bg-color="transparent" @click="gtag('event', 'select_content', {'ad_name': 'TOP공통배너',});">
        <template v-slot="{ component, row }">
          <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
        </template>
      </display-container>

      <!-- PC -->
      <!--<ins class="adsbygoogle"
       style="display:block"
       data-ad-client="ca-pub-5310971739125617"
       data-ad-slot="7094374816"
       data-ad-format="auto"
       data-full-width-responsive="true"></ins>-->

      <!-- M -->
      <!--<ins class="adsbygoogle"
       style="display:block"
       data-ad-client="ca-pub-5310971739125617"
       data-ad-slot="4963035494"
       data-ad-format="auto"
       data-full-width-responsive="true"></ins>-->

    </div>
  </header>

</template>

<script>
  import CommonMethods from 'src/_mixins/CommonMethods'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    name: 'SubHeader',
    components: {
      DisplayContainer
    },
    computed: {
      ...CommonComputed
    },
		methods: {
			...CommonMethods,
      isCurrentGNB (name) {
        return this.$route.path.indexOf(name) > -1
      },
		}
  }
</script>

<style scoped>
  .ad_wrap.head {
    min-width: 1270px;
    padding: 0;
    text-align: center;
    position: relative;
    top: -40px;
  }
  .ad_wrap.head.home /deep/ a {
    margin-bottom: -20px;
  }
  .ad_wrap.head.home /deep/ a img {
    width: 728px !important;
    height: 90px !important;
  }
  .wallpaper .ad_wrap.head {
    background: #fff;
  }
</style>
